.loader {
  display: block;
  font-size: 5px;
  width: 1.2em;
  height: 1.2em;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  animation: mulShdSpin 1.1s infinite ease;
  transform: translateZ(0);
}

@keyframes mulShdSpin {
  0%,
  100% {
    box-shadow:
      0em -2.6em 0em 0em rgba(var(--ogm-timberwolves-rgb), 1),
      1.8em -1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      2.5em 0em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      1.75em 1.75em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      0em 2.5em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      -1.8em 1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      -2.6em 0em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.5),
      -1.8em -1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.7);
  }
  12.5% {
    box-shadow:
      0em -2.6em 0em 0em rgba(var(--ogm-timberwolves-rgb), 0.7),
      1.8em -1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 1),
      2.5em 0em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      1.75em 1.75em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      0em 2.5em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      -1.8em 1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      -2.6em 0em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      -1.8em -1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.5);
  }
  25% {
    box-shadow:
      0em -2.6em 0em 0em rgba(var(--ogm-timberwolves-rgb), 0.5),
      1.8em -1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.7),
      2.5em 0em 0 0em rgba(var(--ogm-timberwolves-rgb), 1),
      1.75em 1.75em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      0em 2.5em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      -1.8em 1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      -2.6em 0em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      -1.8em -1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3);
  }
  37.5% {
    box-shadow:
      0em -2.6em 0em 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      1.8em -1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.5),
      2.5em 0em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.7),
      1.75em 1.75em 0 0em rgba(var(--ogm-timberwolves-rgb), 1),
      0em 2.5em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      -1.8em 1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      -2.6em 0em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      -1.8em -1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3);
  }
  50% {
    box-shadow:
      0em -2.6em 0em 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      1.8em -1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      2.5em 0em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.5),
      1.75em 1.75em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.7),
      0em 2.5em 0 0em rgba(var(--ogm-timberwolves-rgb), 1),
      -1.8em 1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      -2.6em 0em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      -1.8em -1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3);
  }
  62.5% {
    box-shadow:
      0em -2.6em 0em 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      1.8em -1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      2.5em 0em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      1.75em 1.75em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.5),
      0em 2.5em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.7),
      -1.8em 1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 1),
      -2.6em 0em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      -1.8em -1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3);
  }
  75% {
    box-shadow:
      0em -2.6em 0em 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      1.8em -1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      2.5em 0em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      1.75em 1.75em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      0em 2.5em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.5),
      -1.8em 1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.7),
      -2.6em 0em 0 0em rgba(var(--ogm-timberwolves-rgb), 1),
      -1.8em -1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3);
  }
  87.5% {
    box-shadow:
      0em -2.6em 0em 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      1.8em -1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      2.5em 0em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      1.75em 1.75em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      0em 2.5em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.3),
      -1.8em 1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.5),
      -2.6em 0em 0 0em rgba(var(--ogm-timberwolves-rgb), 0.7),
      -1.8em -1.8em 0 0em rgba(var(--ogm-timberwolves-rgb), 1);
  }
}
